import React, { useLayoutEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { logout } from 'app/shared/reducers/authentication';
import { Navigate, useLocation } from 'react-router-dom';
import { resetFilter } from 'app/entities/filters/filters.reducer';
import { resetCommon } from 'app/entities/common/common.reducer';

export const Logout = () => {
  const logoutUrl = useAppSelector(state => state.authentication.logoutUrl);
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();

  useLayoutEffect(() => {
    dispatch(resetFilter())
    dispatch(resetCommon())
    dispatch(logout());
    if (logoutUrl) {
      window.location.href = logoutUrl;
    }
  });
  const { from } = pageLocation.state || { from: { pathname: '/login', search: pageLocation.search } };
  return <Navigate to={from} replace />;
};

export default Logout;
